import { useEffect, useState } from 'react'
import { usePagination } from '@table-library/react-table-library/pagination'
import axios from 'axios'
import { useTheme } from '@table-library/react-table-library/theme'
import {
  DEFAULT_OPTIONS,
  getTheme,
} from '@table-library/react-table-library/material-ui'

import { TABLE_THEME, SERVER_URL } from '../../../constants'
import ManageTable from './ManageTable'

function ManageRestock() {
  const [storedData, setStoredData] = useState({ nodes: [] })
  const [displayedData, setDisplayedData] = useState({ nodes: [] })

  useEffect(() => {
    renderTable()
  }, [])

  const columns = [
    { label: 'Name', renderCell: (item) => item.item_name },
    { label: 'Amount in Stock', renderCell: (item) => item.item_amount },
    { label: 'Minimum Required', renderCell: (item) => item.min_req },
  ]

  const materialTheme = getTheme(DEFAULT_OPTIONS)
  const COLUMN_THEME = {
    Table: `
      --data-table-library_grid-template-columns: 34% 33% 33%;
    `,
  }
  const theme = useTheme([materialTheme, TABLE_THEME, COLUMN_THEME])

  const pagination = usePagination(displayedData, {
    state: {
      page: 0,
      size: 5,
    },
  })

  async function renderTable() {
    let restockRes = await axios.get(`${SERVER_URL}/ingredients/restock`)

    if (restockRes) {
      setDisplayedData({ nodes: restockRes.data })
      setStoredData({ nodes: restockRes.data })
    }
  }

  return (
    <>
      <ManageTable
        searchProps={{
          name: 'Ingredients',
          property: 'ingredient',
          data: storedData,
          setData: setDisplayedData,
        }}
        columns={columns}
        displayedData={displayedData}
        theme={theme}
        pagination={pagination}
      />
    </>
  )
}

export default ManageRestock
